// extracted by css-extract-rspack-plugin
export default {"container":"Seprator-module__container","noMargin":"Seprator-module__noMargin"};